import { StandardWebFormMoreSettings } from './StandardWebFormMoreSettings'
import { NumberWebFormMoreSettings } from './NumberWebFormMoreSettings'
import { CalculationWebFormMoreSettings } from './CalculationWebFormMoreSettings'

export const getWebFormsMoreSettings = ({ type }) => {
  const moreSettings = {
    Calculation: CalculationWebFormMoreSettings,
    Number: NumberWebFormMoreSettings,
  }
  return moreSettings[type] || StandardWebFormMoreSettings
}
